import { Alert, Platform } from 'react-native';

export const customAlertMessage = () => {
    if (Platform.OS === 'web') {
        const modal = document.createElement('div');

        modal.innerHTML = `
        <div id="customAlertOverlay" style="
        position:fixed;
        top:0;
        left:0;
        width:100%;
        height:100%;
        background:rgba(0,0,0,0.6);
        backdrop-filter:blur(5px);
        display:flex;
        justify-content:center;
        align-items:center;
        z-index:99999;
        animation:fadeIn .25s ease;
      ">
        <div style="
          background:#fff;
          padding:30px;
          border-radius:20px;
          max-width:420px;
          width:90%;
          text-align:center;
          box-shadow:0 20px 50px rgba(0,0,0,0.25);
          animation:popup .25s ease;
          font-family:system-ui,-apple-system,sans-serif;
        ">
          
          <div style="
            width:70px;
            height:70px;
            margin:0 auto 16px;
            border-radius:50%;
            background:#dcfce7;
            display:flex;
            align-items:center;
            justify-content:center;
            font-size:34px;
          ">
            ⏳
          </div>

          <h2 style="
            margin:0 0 10px;
            color:#1f2937;
            font-size:24px;
            font-weight:700;
          ">
            অনুগ্রহ করে অপেক্ষা করুন
          </h2>

          <div style="
            width:60px;
            height:4px;
            margin:0 auto 18px;
            border-radius:999px;
            background:linear-gradient(90deg,#16a34a,#22c55e);
          "></div>

          <p style="
            margin:0;
            color:#475569;
            font-size:15px;
            line-height:1.8;
          ">
            এই ফিচারটি এখনো প্রস্তুত নয়।
            <br/>
            খুব শীঘ্রই এটি আপনার জন্য উন্মুক্ত করা হবে।
          </p>

          <p style="
            margin:18px 0 24px;
            color:#16a34a;
            font-size:20px;
            font-weight:700;
          ">
            ধন্যবাদ 🌟
          </p>

          <button
            id="customAlertClose"
            style="
              padding:12px 32px;
              border:none;
              border-radius:12px;
              background:linear-gradient(135deg,#16a34a,#22c55e);
              color:white;
              font-size:16px;
              font-weight:600;
              cursor:pointer;
              box-shadow:0 4px 12px rgba(34,197,94,0.35);
              transition:all .25s ease;
              min-width:130px;
            "
            onmouseover="
              this.style.transform='translateY(-2px)';
              this.style.boxShadow='0 8px 20px rgba(34,197,94,0.45)';
            "
            onmouseout="
              this.style.transform='translateY(0)';
              this.style.boxShadow='0 4px 12px rgba(34,197,94,0.35)';
            "
            onmousedown="
              this.style.transform='scale(0.96)';
            "
            onmouseup="
              this.style.transform='translateY(-2px)';
            "
          >
            ✓ ঠিক আছে
          </button>

        </div>
      </div>
    `;

        const style = document.createElement('style');
        style.innerHTML = `
      @keyframes fadeIn {
        from { opacity:0; }
        to { opacity:1; }
      }

      @keyframes popup {
        from {
          opacity:0;
          transform:scale(.9);
        }
        to {
          opacity:1;
          transform:scale(1);
        }
      }
    `;

        document.head.appendChild(style);
        document.body.appendChild(modal);

        const closeModal = () => {
            modal.remove();
            style.remove();
        };

        document
            .getElementById('customAlertClose')
            ?.addEventListener('click', closeModal);

        document
            .getElementById('customAlertOverlay')
            ?.addEventListener('click', (e) => {
                if (e.target.id === 'customAlertOverlay') {
                    closeModal();
                }
            });

        return;
    }

    // Android & iOS
    Alert.alert(
        '⏳ অনুগ্রহ করে অপেক্ষা করুন',
        'এই ফিচারটি এখনো প্রস্তুত নয়।\nখুব শীঘ্রই এটি আপনার জন্য উন্মুক্ত করা হবে।\n\nধন্যবাদ 🌟',
        [{ text: 'ঠিক আছে' }]
    );
};